import { useContext } from 'react';
import { ImageContext } from '../../context/ImageContext';
import { LocationAndCraneCoverageWrapper, EditImage } from './styles';

const LocationAndCraneCoverageEdit = ({ image }) => {
  const { onSuccessImageUpload, onSuccessImageRemove, shouldSendDeleteImageReq } = useContext(ImageContext);

  return (
    <LocationAndCraneCoverageWrapper>
      <EditImage
        imageId={image.imageId}
        imageArrIndex={8}
        onImageUpload={onSuccessImageUpload}
        onImageRemove={onSuccessImageRemove}
        shouldSendDeleteImageReq={shouldSendDeleteImageReq}
      />
    </LocationAndCraneCoverageWrapper>
  );
};

export default LocationAndCraneCoverageEdit;
